export const messageStatuses = {
  read: 'read',
  sent: 'sent',
  delivered: 'delivered',
  undelivered: 'undelivered',
  unread: 'unread',
  open: 'open',
  processed: 'processed',
  dropped: 'dropped',
  bounced: 'bounced',
  click: 'click',
};

export const messageTypes = {
  text: 'text',
  file: 'file',
  product: 'product',
  collection: 'collection',
  notification: 'notification',
  sms: 'SMS',
  email: 'EMAIL',
  voice: 'VOICE',
};

export const messageDirections = {
  inbound: 'Inbound',
  outbound: 'Outbound',
};
